import gql from 'graphql-tag';

const allLawyers = gql`
  query AllLawyers($litigationCountries: [String]) {
    allLawyers(filter: { litigationCountries: $litigationCountries }) {
      id
      name
      lawFirm {
        id
        name
      }
    }
  }
`;

export { allLawyers };



// WEBPACK FOOTER //
// ./src/queries/AllLawyers.js